
import { BiBriefcaseAlt2 } from "react-icons/bi";
import { BsStars } from "react-icons/bs";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";

import Header from "../components/Header";
import { experience, jobTypes } from "../utils/data";
import { CustomButton, JobCard, ListBox } from "../components";
import axios from "axios";
import { useEffect, useState } from "react";

const FindJobs = () => {
  const [recordsCount, setRecordsCount] = useState(0);
 const [cmpLocation, setCmpLocation] = useState("");
 const [sort, setSort] = useState('Newest');
  
 const [page, setPage] = useState(1);
 const [numPage, setNumPage] = useState(1);
 const [data, setData] = useState([]);

 const [searchQuery, setSearchQuery] = useState("");
 const [jobLocation, setJobLocation] = useState("");
 const [filterJobTypes, setFilterJobTypes] = useState([]);
 const [filterExp, setFilterExp] = useState([]);
 const [profileUrl, setProfileUrl] = useState('');
 const[fetched ,setfetched] =useState(false);

 const [isFetching, setIsFetching] = useState(false);
 
 useEffect(() => {
  if (!fetched) {
    const fetchData1 = async () => {
      console.log(filterExp ,profileUrl ,setCmpLocation);
      
        setIsFetching(true);
        try {
          if(!fetched){
          const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/job/find-jobs`, {
            params: {
              search: searchQuery,
              sort,
              location: cmpLocation,
              page,
            },
          });
          setfetched(true)
          setData(prevData => [...prevData, ...response.data.data]); // Append new data to existing data
          setProfileUrl(response.data.data);
          console.log(response.data);
          setRecordsCount(response.data.totalJobs);
          setNumPage(response.data.numOfPage);
          setIsFetching(false);}
        } catch (error) {
          console.error('Error fetching jobs:', error);
          setIsFetching(false);
        }
     };
     fetchData1();
  }
}, [cmpLocation,fetched,page,profileUrl,searchQuery, sort,filterExp]); // Include fetchData in the dependency array



const fetchData = async () => {
  console.log(filterExp ,profileUrl ,setCmpLocation);
  
    setIsFetching(true);
    try {
      if(!fetched){
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/job/find-jobs`, {
        params: {
          search: searchQuery,
          sort,
          location: cmpLocation,
          page,
        },
      });
      setfetched(true)
      setData(prevData => [...prevData, ...response.data.data]); // Append new data to existing data
      setProfileUrl(response.data.data);
      console.log(response.data);
      setRecordsCount(response.data.totalJobs);
      setNumPage(response.data.numOfPage);
      setIsFetching(false);}
    } catch (error) {
      console.error('Error fetching jobs:', error);
      setIsFetching(false);
    }
 };

 const handleShowMore = () => {
    setPage(prevPage => prevPage + 1); // Correctly increment the page number
 };

 const handleSearchSubmit = async () => {
    setPage(1); // Reset page number when performing a new search
    setData([]); // Clear existing data
    fetchData(); // Fetch data for the first page
 };

 const handleSortChange = (selectedSort) => {
    setSort(selectedSort);
    handleSearchSubmit()
 };

 const filterJobs = (val) => {
    if (filterJobTypes?.includes(val)) {
      setFilterJobTypes(filterJobTypes.filter((el) => el !== val));
    } else {
      setFilterJobTypes([...filterJobTypes, val]);
    }
 };

 const filterExperience = async (e) => {
    setFilterExp(e);
 };

  return (
    <div>
      <Header
        title='Find Your Dream Job with Ease'
        type='home'
        handleClick={() => {}}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        location={jobLocation}
        setLocation={setJobLocation}
      />

      <div className='container mx-auto flex gap-6 2xl:gap-10 md:px-5 py-0 md:py-6 bg-[#f7fdfd]'>
        <div className='hidden md:flex flex-col w-1/6 h-fit bg-white shadow-sm'>
          <p className='text-lg font-semibold text-slate-600'>Filter Search</p>

          <div className='py-2'>
            <div className='flex justify-between mb-3'>
              <p className='flex items-center gap-2 font-semibold'>
                <BiBriefcaseAlt2 />
                Job Type
              </p>

              <button onClick={handleSortChange}>
                <MdOutlineKeyboardArrowDown />
              </button>
            </div>

            <div className='flex flex-col gap-2'>
              {jobTypes.map((jtype, index) => (
                <div key={index} className='flex gap-2 text-sm md:text-base '>
                  <input
                    type='checkbox'
                    value={jtype}
                    className='w-4 h-4'
                    onChange={(e) => filterJobs(e.target.value)}
                  />
                  <span>{jtype}</span>
                </div>
              ))}
            </div>
          </div>

          <div className='py-2 mt-4'>
            <div className='flex justify-between mb-3'>
              <p className='flex items-center gap-2 font-semibold'>
                <BsStars />
                Experience
              </p>

              <button>
                <MdOutlineKeyboardArrowDown />
              </button>
            </div>

            <div className='flex flex-col gap-2'>
              {experience.map((exp) => (
                <div key={exp.title} className='flex gap-3'>
                  <input
                    type='checkbox'
                    value={exp?.value}
                    className='w-4 h-4'
                    onChange={(e) => filterExperience(e.target.value)}
                  />
                  <span>{exp.title}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className='w-full md:w-5/6 px-5 md:px-0'>
          <div className='flex items-center justify-between mb-4'>
            <p className='text-sm md:text-base'>
              Showing: <span className='font-semibold'>{recordsCount}</span> Jobs
              Available
            </p>

            <div className='flex flex-col md:flex-row gap-0 md:gap-2 md:items-center'>
              <p className='text-sm md:text-base'>Sort By:</p>

              <ListBox sort={sort} setSort={setSort} />
            </div>
          </div>

          <div className='w-full flex flex-wrap gap-4'>
            {data.map((job, index) => (
              <JobCard job={job} key={index}  profileUrl={job.company.profileUrl}/>
            ))}
          </div>
          {data.length > 0 && (
            <p className='text-sm text-right'>
              {data.length} records out of {recordsCount}
            </p>
          )}
          {numPage > page && !isFetching && (
            <div className='w-full flex items-center justify-center pt-16'>
              <CustomButton
              onClick={handleShowMore}
                title='Load More'
                containerStyles={`text-blue-600 py-1.5 px-5 focus:outline-none hover:bg-blue-700 hover:text-white rounded-full text-base border border-blue-600`}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FindJobs;
